import React from "react";
import "./home.css";
import { Link } from "react-router-dom";



const ItemCard = ({ name, title, image, route, fadeside }) => {
    if (fadeside==1)
    return (
        <Link to={route} className="item-menu col-6" >
            <img src={image} alt="Product" />
            <h1>{name}</h1>
            <h6>{title}</h6>
        </Link>
        );
    else
        return (
            <Link to={route} className="item-menu col-6" >
                    <img src={image} alt="Product" />
                    <h1>{name}</h1>
                    <h6>{title}</h6>
            </Link>
        );
};

export default ItemCard;
